import { Category } from "api/main";

export const getHeaderItems = (
  isCRDC: boolean,
  t: any,
  servicesCategories?: Category[],
  locale?: string
) => {
  const HeaderItems = isCRDC
    ? [
        { title: t("MainPage"), path: "/research" },
        {
          title: t("IntroductionOfTheUnit"),

          children: [
            {
              title: t("HistoryUnit"),
              path: "/research/unit-history",
              children: null,
            },
            {
              title: t("IntroductionOfTheCenter"),
              path: "/research/unit-introduction",
            },
          ],
        },
        { title: t("GoalsAndPlans"), path: "/research/plans" },
        {
          title: t("AchievementsOfTheUnit"),
          children: [
            {
              title: t("Innovation"),
              path: "/research/unit-achievements/invention",
              children: null,
            },
            {
              title: t("ResearchWorkshops"),
              path: "/research/unit-achievements/researchWorkshop",
            },
            {
              title: t("ResearchInformationBank"),
              path: "/research/unit-achievements/researchInformationBank",
            },
            {
              title: t("SummaryOfCongressJournals"),
              path: "/research/unit-achievements/printedArticleSummary",
            },
            {
              title: t("PrintedMagazines"),
              path: "/research/unit-achievements/printedArticle",
            },
            {
              title: t("ResearchProjects"),
              path: "/research/unit-achievements/researchProject",
            },
            {
              title: t("Theses"),
              path: "/research/unit-achievements/thesis",
            },
          ],
        },
        {
          title: t("UnitMembers"),
          children: [
            {
              title: t("UnitSupervisor"),
              path: "/research/unit-members/unitSupervisor",
            },
            {
              title: t("DeputySuperintendent"),
              path: "/research/unit-members/deputySuperintendent",
            },
            // {
            //   title: t("DirectoroOfClinicalResearchUnit"),
            //   path: "/research/unit-members/clinicalResearchDirector",
            // },
            // {
            //   title: t("DirectorOfClinicalResearchDevelopmentCenter"),
            //   path: "/research/unit-members/clinicalResearchDevelopmentDirector",
            // },
            // {
            //   title: t("SecretaryoOfTheClinicalResearchDevelopmentCenter"),
            //   path: "/research/unit-members/clinicalResearchDevelopmentSecretary",
            // },
            {
              title: t("UnitCouncil"),
              path: "/research/unit-members/unitCouncil",
            },
            {
              title: t("UnitConsultants"),
              path: "/research/unit-members/unitConsultant",
            },
            {
              title: t("UnitExperts"),
              path: "/research/unit-members/unitExpert",
            },
          ],
        },

        {
          title: t("CommunicationWithTheUnit"),
          path: "/research/contact-us",
        },
      ]
    : [
        {
          title: t("WhyUs"),
          children: [
            {
              title: t("Mission"),
              path: "/why-us/missions",
            },
            {
              title: t("VisionAndValues"),
              path: "/why-us/vision",
            },
            {
              title: t("ourPolicy"),
              path: "/why-us/our-policy",
            },
            {
              title: t("HospitalIntroduction"),
              path: "/why-us/introduction",
            },
            {
              title: t("HonorsAndAchievements"),
              path: "/why-us/achivements",
            },
            {
              title: t("Workers"),
              path: "/why-us/workers",
            },
            {
              title: t("PatientExperiences"),
              path: "/why-us/experiences",
            },
          ],
        },
        {
          title: t("VisitorsGuide"),
          children: [
            {
              title: t("Clinic"),
              path: "/visitors-guide/clinic",
            },
            {
              title: t("PatientAdmissionGuide"),
              path: "/visitors-guide/admission",
            },
            {
              title: t("DepartmentsOfValiasrHospital"),
              path: "/visitors-guide/sections",
            },
            {
              title: t("PatientSupportUnit"),
              path: "/visitors-guide/support",
            },
            {
              title: t("InsurancesAndTariffs"),
              path: "/visitors-guide/insurances",
            },
            {
              title: t("PatientsGuide"),
              path: "/visitors-guide/patients",
            },
            {
              title: t("SPAUnit"),
              path: "/visitors-guide/spa",
            },
            {
              title: t("FAQ"),
              path: "/visitors-guide/faq",
            },
            // {
            //   title: t("MeetingGuide"),
            //   path: "/visitors-guide/meeting",
            // },
            // {
            //   title: t("InternationalPatients"),
            //   path: "/visitors-guide/international-patients",
            // },
            // {
            //   title: t("KindergartenUnit"),
            //   path: "/visitors-guide/kindergarten",
            // },
          ],
        },
        {
          title: t("Training"),
          children: [
            {
              title: t("PatientEducation"),

              children: [
                {
                  title: t("Diseases"),
                  path: "/teaching/diseases",
                },
                {
                  title: t("Experiments"),
                  path: "/teaching/experiments",
                },
                {
                  title: t("Medicines"),
                  path: "/teaching/medicines",
                },
                {
                  title: t("LifeStyle"),
                  path: "/teaching/lifestyle",
                },
                {
                  title: t("PatientEducationPamphlets"),
                  path: "/teaching/pamphlets",
                },
              ],
            },
          ],
        },
        {
          title: t("ClinicalResearchDevelopmentCenter"),
          path: "/research",
        },
        {
          title: t("1stGradeSpecialHospitalTariff"),
          path: "/visitors-guide/special",
        },
        {
          title: t("Services"),
          children:
            locale !== "en" && servicesCategories
              ? servicesCategories.map((item) => ({
                  title: item.name,
                  path: `/services/${item.id}`,
                }))
              : [
                  { title: "abdominoplasty", path: "/services/230/404" },
                  { title: "Endoscopic spine surgery", path: "/services/230/389" },
                  { title: "Coronary Artery Bypass Graft", path: "/services/230/388" },
                  { title: "Mammaplasty", path: "/services/230/382" },
                  { title: "Hip Replacement Surgery", path: "/services/230/386" },
                  { title: "Colectomy", path: "/services/230/385" },
                ],
        },
        {
          title: t("MeetingGuide"),
          path: "/visitors-guide/meeting",
        },
        {
          title: t("CommunicateUs"),
          path: "/visitors-guide/contact-us",
        },
        ...(locale === "fa"
          ? [
              {
                title: t("DoctorsSignIn"),
                path: "http://2.186.118.90:9009/default.aspx?ReturnUrl=%2f",
              },
            ]
          : []),
      ];

  return HeaderItems;
};

export const getSideBarItems = (isCRDC: boolean, t: any) => {
  const temp = [
    { title: t("Regulations"), path: "/research/regulations" },
    { title: t("Rules"), path: "/research/rules" },
    {
      title: t("ResearchConsultancy"),

      children: [
        {
          title: t("ServicesConsaltant"),
          path: "/research/research-consultancy",
        },
        {
          title: t("TimeConsaltant"),
          path: "/research/research-consultancy",
        },
        {
          title: t("ElectronicConsaltant"),
          path: "/research/contact-us",
        },
      ],
    },
    {
      title: t("ResearchCouncilMeetings"),
      children: [
        {
          title: t("ResearchCouncilMeetings"),
          path: "/research/meeting-calender",
        },
        {
          title: t("MinutesOfMeetings"),
          path: "/research/meeting",
        },
      ],
    },
    {
      title: t("EducationalContent"),
      path: "/research/clinical-content",
    },
    {
      title: t("Covid19"),
      children: ["covid"],
    },

    {
      title: t("TeachingResearch"),
      path: "/research/teaching-research",
    },
    { title: t("Thanking"), path: "/research/thanking" },
    {
      title: t("YoungJam"),
      path: "/research/news/",
    },
    {
      title: t("ElectronicResources"),
      children: [
        {
          title: "E.Books, Atlases & CME",
          path: "/research/electronic-resource/0",
        },
        {
          title: " Data Base ",
          path: "/research/electronic-resource/1",
        },
        {
          title: " e-journal",
          path: "/research/electronic-resource/2",
        },
        {
          title: "Evidence Based Medicine",
          path: "/research/electronic-resource/3",
        },
        {
          title: "Medical Images, Protocol, Interactive Skills & Procedure",
          path: "/research/electronic-resource/4",
        },
      ],
    },
  ];

  return temp;
};
